import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import moment from "jalali-moment";

/////
import LogOut from "../user/logout/logout";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";





const ShowPayment = () => {
    const { token } = useSelector((item) => item.user)
    var { t } = useTranslation();

    ////nft  ساخته شده
    const [data, setData] = useState(null)

    useEffect(() => {
        getDashboardData()
    }, [])


    async function getDashboardData() {
        await fetch(`${process.env.REACT_APP_SERVER}/api/user/dashboard`, {
            method: "GET",
            headers: {
                Authorization: "ArNew " + token,
            },
        }).then((res) => {
            res
                .json()
                .then((result) => {
                    if (!result.data) {
                        LogOut();
                        toast.error("شما دسترسی ندارید");
                        window.location.href = '/auth';
                    }
                    if (result.status === "success") {
                        setData(result.data)
                    } else {
                        toast.error(result.msg);
                        LogOut();
                        window.location.href = 'login';
                    }
                })
                .catch((error) => {
                    // window.location.href = '/auth';
                    console.log(error);
                });
        });
    }


    const typePaymentDate = (type) => {
        switch (type) {
            case "DAILY":
                return "روزانه"
            case "MONTHLY":
                return "ماهانه"
            case "YEARLY":
                return "سالانه"
            default:
                return "روزانه"
        }
    }

    const formatPrice = (value) => {
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };

    const timeNow = Date.now();
    

    return (
        <>
            <div className="grid grid-cols-1 xl:grid-cols-3 lg:grid-cols-2 gap-3 ">
                <div className="block w-full  p-10 bg-white border border-gray-200 rounded-lg shadow-md justify-self-center hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
                    <div className="flex justify-center w-full mb-3 ">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" className="w-12 h-12">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                    </div>
                    <h5 className="mb-2 text-base font-bold tracking-tight text-center text-gray-900 dark:text-white">پروژه های ساخته شده</h5>
                    <p className="font-medium text-lg  text-center text-gray-700 dark:text-gray-400"><span className="text-sm">براساس نشانگر:</span> {data != null ? data.markerCount : 0}</p>
                    <p className="font-medium text-lg  text-center text-gray-700 dark:text-gray-400"><span className="text-sm">براساس بدون نشانگر:</span> {data != null ? data.markerLessCount : 0}</p>
                </div>

                <div className="block w-full  p-10 bg-white border border-gray-200 rounded-lg shadow-md justify-self-center hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
                    <div className="flex justify-center w-full mb-3 ">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" className="w-12 h-12">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 8.25h19.5M2.25 9h19.5m-16.5 5.25h6m-6 2.25h3m-3.75 3h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5z" />
                        </svg>
                    </div>
                    <h5 className="mb-2 text-base font-bold tracking-tight text-center text-gray-900 dark:text-white">اشتراک {data != null ? typePaymentDate(data.payments.type) : null}</h5>
                    {data != null ?
                        data.payments.type == "DAILY" ?
                            data.payments.status == 0 ?
                                (
                                    <>
                                        <p className="font-medium text-base text-center text-gray-600 dark:text-gray-400">به علت کافی نبودن شارژ حساب غیرفعال می باشد</p>
                                        <Link to="/pay/increase">
                                            <p className="font-medium text-base text-center text-gray-700 dark:text-gray-400">اعتبار باقیمانده: {formatPrice(data.payments.balance.toString())} تومان</p>
                                        </Link>
                                    </>
                                )
                                :
                                (
                                    <>
                                        <Link to="/pay/increase">
                                            <p className="font-medium text-base text-center text-gray-700 dark:text-gray-400">اعتبار باقیمانده: {formatPrice(data.payments.balance.toString())} تومان</p>
                                        </Link>
                                    </>
                                )
                            :
                            <>
                                <p className="font-medium text-base text-center text-gray-600 dark:text-gray-400">معتبر تا تاریخ</p>
                                <p className="font-medium text-base text-center text-gray-700 dark:text-gray-400">{moment(new Date(parseInt(data.payments.expire_in))).format("jYYYY/jMM/jDD")}</p>
                            </>
                        :
                        (
                            <>
                                <p className="font-medium text-lg text-center text-gray-700 dark:text-gray-400">درحال بارگذاری</p>
                            </>
                        )
                    }
                    {
                        data && data.payments && data.payments.type == "DAILY" &&
                        <p className={`font-medium text-lg text-center ${data.payments.status == true ? "text-green-700" : "text-red-700"}  dark:text-gray-400`}>{data.payments.status == true ? "فعال" : "غیرفعال"}</p>
                    }
                    {
                        data && data.payments && data.payments.type != "DAILY" &&
                        <p className={`font-medium text-lg text-center ${parseInt(data.payments.expire_in) > timeNow ? "text-green-700" : "text-red-700"}  dark:text-gray-400`}>{parseInt(data.payments.expire_in) > timeNow ? "فعال" : "غیرفعال"}</p>
                    }
                </div>

                <div className="block w-full  p-10 bg-white border border-gray-200 rounded-lg shadow-md justify-self-center hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
                    <div className="flex justify-center w-full mb-3 ">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor" className="w-12 h-12">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 3.75H6A2.25 2.25 0 003.75 6v1.5M16.5 3.75H18A2.25 2.25 0 0120.25 6v1.5m0 9V18A2.25 2.25 0 0118 20.25h-1.5m-9 0H6A2.25 2.25 0 013.75 18v-1.5M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                    </div>
                    <h5 className="mb-2 text-base font-bold tracking-tight text-center text-gray-900 dark:text-white">تعداد بازدید همه پروژه ها</h5>
                    <p className="font-medium text-lg text-center text-gray-700 dark:text-gray-400">{data != null ? data.sumViews : 0}</p>
                    <p className="font-medium text-sm text-center text-gray-700 dark:text-gray-400">از {data != null ? (data.markerCount + data.markerLessCount) : 0} پروژه</p>
                </div>
            </div>
        </>


    )



}


export default ShowPayment;